import { jsxs as o, jsx as t } from "react/jsx-runtime";
import { IconButton as u, Divider as D } from "@mui/material";
import { useState as T, useEffect as g, Fragment as C } from "react";
import { formatDate as y, addDaysToDate as f } from "../../helpers/dates.js";
import { l as j, m as v } from "../../index-DVHhaa_b.js";
import '../../assets/daypicker.css';const x = "_daypicker_1tjz4_1", A = "_datebutton_1tjz4_13", I = "_month_1tjz4_15", M = "_date_1tjz4_13", B = "_day_1tjz4_1", E = "_number_1tjz4_65", F = "_selected_1tjz4_75", e = {
  daypicker: x,
  datebutton: A,
  month: I,
  date: M,
  day: B,
  number: E,
  selected: F
}, b = [-2, -1, 0, 1, 2, 3], W = ({ selectedDate: k, onChange: N, outerDate: c }) => {
  const [d, r] = T([...b]);
  g(() => {
    r([...b]);
  }, [c]);
  const m = (i) => {
    r(d.map((n) => n + i));
  };
  return /* @__PURE__ */ o("div", { className: e.daypicker, children: [
    /* @__PURE__ */ t(u, { onClick: () => m(-1), children: /* @__PURE__ */ t(j, { iconType: v.ChevronLeft }) }),
    d.map((i, n) => {
      const l = y(f(c, d[0])).shortMonth, s = f(c, i), { dayOfWeek: z, shortMonth: h, dateNumber: _ } = y(s);
      let a;
      n === 0 ? a = l : h !== l && _ === 1 && (a = h);
      const p = [e.date];
      return s.getTime() === k.getTime() && p.push(e.selected), /* @__PURE__ */ o(C, { children: [
        n !== 0 && a && /* @__PURE__ */ t(D, { orientation: "vertical", variant: "middle", flexItem: !0 }),
        /* @__PURE__ */ o("div", { className: e.datebutton, onClick: () => N(s), children: [
          /* @__PURE__ */ t("div", { className: e.month, children: a }),
          /* @__PURE__ */ o("div", { className: p.join(" "), children: [
            /* @__PURE__ */ t("div", { className: e.day, children: z }),
            /* @__PURE__ */ t("div", { className: e.number, children: _ })
          ] })
        ] })
      ] }, s.getTime());
    }),
    /* @__PURE__ */ t(u, { onClick: () => m(1), children: /* @__PURE__ */ t(j, { iconType: v.ChevronRight }) })
  ] });
};
export {
  W as DayPicker
};
//# sourceMappingURL=daypicker.js.map
